import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layout__wrapper" }
const _hoisted_2 = { class: "billing-details" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "plan-payment" }
const _hoisted_5 = {
  key: 0,
  class: "billing-cancel"
}
const _hoisted_6 = { class: "billing-cancel__text" }
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  key: 1,
  class: "billing-cancel"
}
const _hoisted_9 = { class: "billing-cancel__text" }
const _hoisted_10 = ["href"]

import { computed } from 'vue'

import type { BillingView } from '@/models/billing'

import PlanInfoMonthly from './BillingDataPaid.PlanInfo.Monthly.vue'
import PlanInfoAnnual from './BillingDataPaid.PlanInfo.Annual.vue'
import InfoQuestions from './InfoQuestions.vue'

import BillingNotifications from './BillingNotifications.vue'
import { Mixpanel } from '@/analytics/mixpanel'


export default /*@__PURE__*/_defineComponent({
  __name: 'BillingDataPaidAppStore',
  props: {
    billing: {}
  },
  setup(__props: any) {

const props = __props

const paymentProviderSettingsText = computed(() => {
  if (props.billing.billing_type === 'apple') {
    return 'Please use Apple UI to manage your subscription.'
  }
  return 'Manage your subscription on Google Play.'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(BillingNotifications, { billing: __props.billing }, null, 8, ["billing"]),
        _createElementVNode("div", _hoisted_4, [
          (__props.billing.plan.id === 'plan_monthly')
            ? (_openBlock(), _createBlock(PlanInfoMonthly, {
                key: 0,
                billing: __props.billing
              }, null, 8, ["billing"]))
            : _createCommentVNode("", true),
          (__props.billing.plan.id === 'plan_annual')
            ? (_openBlock(), _createBlock(PlanInfoAnnual, {
                key: 1,
                billing: __props.billing
              }, null, 8, ["billing"]))
            : _createCommentVNode("", true)
        ]),
        (__props.billing.cancel_at_period_end)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, [
                _cache[2] || (_cache[2] = _createTextVNode(" Want to reactivate your Shortform subscription? ", -1)),
                _createElementVNode("a", {
                  class: "billing-cancel__link",
                  href: __props.billing.paymentProviderSettingsUrl,
                  target: "_blank",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(Mixpanel).trackCancelSubscriptionClick()))
                }, [
                  _createElementVNode("span", null, _toDisplayString(paymentProviderSettingsText.value), 1)
                ], 8, _hoisted_7),
                _cache[3] || (_cache[3] = _createTextVNode(". ", -1))
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("p", _hoisted_9, [
                _cache[4] || (_cache[4] = _createTextVNode(" Want to stop your Shortform subscription? ", -1)),
                _createElementVNode("a", {
                  class: "billing-cancel__link",
                  href: __props.billing.paymentProviderSettingsUrl,
                  target: "_blank",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(Mixpanel).trackCancelSubscriptionClick()))
                }, [
                  _createElementVNode("span", null, _toDisplayString(paymentProviderSettingsText.value), 1)
                ], 8, _hoisted_10),
                _cache[5] || (_cache[5] = _createTextVNode(". ", -1))
              ])
            ]))
      ])
    ]),
    _createVNode(InfoQuestions)
  ]))
}
}

})